module.exports = __webpack_public_path__ + "media/images/footer/en_efs-5804708353c9cb4053d43d953719f9da.svg";